import axios from 'axios';

export default axios.create({
  baseURL: 'https://app01-server.herokuapp.com',
  withCredentials: false,
  headers: {
    'Content-type': 'application/json',
  },
});
